// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   KYB Verification CSS
   ========================================================= */

.kyb_verification_page {
  padding: 30px;
  max-width: 100%;
}

.kyb_page_header {
  margin-bottom: 30px;
}

.kyb_page_header h1 {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #fff;
}

.kyb_page_header p {
  color: #84878A;
  font-size: 16px;
}

/* START PAGE */
.kyb_start_layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}


.kyb_start_left {
  flex: 1 1;
}

.kyb_start_right {
  width: 360px;
  flex-shrink: 0;
}



.kyb_box {
  background: #2b313d52;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 20px;
  border: 1px solid #2b3139;
}

/* Hero Box */
.kyb_hero_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.kyb_hero_content {
  max-width: 340px;
}

.kyb_hero_content h2 {
  font-size: 23px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #fff;
}

.kyb_hero_content p {
  color: #828282;
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.5;
}

.kyb_hero_list {
  list-style: none;
  padding: 0;
  margin: 0 0 25px 0;
}

.kyb_hero_list li {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #e0e0e0;
  font-size: 14px;
  margin-bottom: 12px;
}

.kyb_hero_list li i {
  height: 16px;
  display: flex;
  width: 16px;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  color: #b7b7b7;
  background: #ffffff00;
  border: 1px solid #a3a3a3;
  border-radius: 50%;
  font-size: 12px;
}

.kyb_start_btn {
  background: #2b313c;
  color: #fff;
  border: none;
  padding: 13px 32px;
  border-radius: 50px;
  font-weight: 400;
  letter-spacing: 0.5px;
  font-size: 13px;
  transition: opacity 0.2s;
  cursor: pointer;
}

.kyb_start_btn:hover {
  opacity: 0.8;
}

.kyb_start_btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.kyb_status_cta {
  margin: 8px 0 24px;
}

.kyb_status_actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
  margin: 8px 0 24px;
}

.kyb_status_banner {
  margin: 0 0 16px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(209, 170, 103, 0.35);
  background: rgba(209, 170, 103, 0.08);
}

.kyb_status_banner_title {
  font-size: 15px;
  font-weight: 600;
  color: #d1aa67;
  margin-bottom: 6px;
}

.kyb_status_banner_text {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #cdcdcd;
}

.kyb_status_vendor {
  display: inline-block;
  margin-top: 8px;
  font-size: 12px;
  color: #a3a3a3;
}

.kyb_info_value.pending_value {
  color: #d1aa67;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.kyb_help_btn_outline {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.kyb_hero_img {
  width: 350px;
}

/* Required Documents Box */
.kyb_docs_box h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #fff;
}

.kyb_docs_box>p {
  color: #cdcdcd;
  font-size: 13px;
  margin-bottom: 20px;
}

body.light_theme .kyb_docs_box>p {
  color: #4E4638;
}

.kyb_docs_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.kyb_doc_card {
  background: #2b313c91;
  border-radius: 8px;
  min-height: 105px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.kyb_doc_icon {
  width: 34px;
  min-width: 34px;
  height: 42px;
  background: #858585;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .kyb_doc_icon {
  background: #1e2329;
}

.kyb_doc_icon img {
  width: auto;
  object-fit: contain;
  filter: invert(1);
}

body.light_theme .kyb_doc_icon img {
  filter: invert(0);
}

.kyb_doc_info h4 {
  font-size: 13px;
  letter-spacing: 0.8px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 3px;
}

.kyb_doc_info p {
  font-size: 12px;
  color: #cfcfcf;
  margin: 0;
  line-height: 1.4;
}

body.light_theme .kyb_doc_info p {
  color: #4E4638;
}

/* FAQ Box */
.kyb_faq_box h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #fff;
}

.kyb_faq_list {
  display: flex;
  flex-direction: column;
}

.kyb_faq_item {
  border-bottom: 1px solid #2b3139;
}

.kyb_faq_item:last-child {
  border-bottom: none;
}

.kyb_faq_question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  color: #e0e0e0;
  font-size: 14px;
  cursor: pointer;
}

.kyb_faq_question i {
  color: #848e9c;
}

.kyb_faq_answer {
  padding-bottom: 15px;
  color: #848e9c;
  font-size: 13px;
  line-height: 1.5;
  display: none;
}

.kyb_faq_item.active .kyb_faq_answer {
  display: block;
}

.kyb_faq_item.active .kyb_faq_question i {
  transform: rotate(180deg);
}

/* STATUS PAGES (Pending, Success, Failed) */
.kyb_status_container {
  width: 100%;
  text-align: center;
}

.kyb_status_icon_wrap {
  width: 360px;
  /* height: 80px; */
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kyb_status_icon_wrap img {
  object-fit: contain;
}

.kyb_status_title {
  font-size: 38px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  margin-top: -40px;
}

.successfull .kyb_status_title {
  margin-top: 0px;
}

.kyb_status_title span.pending {
  color: #DAA520;
}

.kyb_status_container.pending_section h2 {
  margin-top: 20px;
}

.kyb_status_title span.failed {
  color: #f6465d;
}

.kyb_status_title span.success {
  color: #d1aa67;
}

.kyb_status_desc {
  color: #84878A;
  font-size: 18px;
  margin-bottom: 40px;
}

/* Info Grid */
.kyb_info_card {
  background: #2b3139;
  border-radius: 20px;
  padding: 36px;
  border: 1px solid #f2f3f417;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 26px;
  text-align: left;
  margin-bottom: 30px;
}

body.light_theme .kyb_info_card {
  border: 1px solid #F2F3F4;
}

@media(max-width: 600px) {
  .kyb_info_card {
    grid-template-columns: 1fr;
  }
}

.kyb_info_item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.kyb_info_icon {
  background-color: rgba(209, 170, 103, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
}

body.light_theme .kyb_info_icon {
  background-color: #FDF8E7;
}

.kyb_info_text {
  flex: 1 1;
}

.kyb_info_label {
  color: #848e9c;
  font-size: 14px;
  margin-bottom: 4px;
}

.failled_section .kyb_info_icon {
  background-color: #fef2f208;
}

body.light_theme .failled_section .kyb_info_icon {
  background-color: #FEF2F2;
}

.kyb_info_value {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.kyb_info_value.failed {
  color: #f6465d;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(246, 70, 93, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
}

.kyb_info_value.success {
  color: #d1aa67 !important;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(209, 170, 103, 0.14);
  padding: 2px 8px;
  border-radius: 4px;
}

/* Alerts / Extra Boxes */
.kyb_help_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(240, 185, 11, 0.05);
  border: 1px solid rgba(240, 185, 11, 0.2);
  border-radius: 12px;
  padding: 24px;
  text-align: left;
}

.kyb_help_left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.kyb_help_icon {
  width: 64px;
  min-width: 64px;
  height: 64px;
  background: #fdf8e70f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .kyb_help_icon {
  background: #FDF8E7;
}

.kyb_help_text h4 {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
}

.kyb_help_text p {
  color: #848e9c;
  font-size: 14px;
  margin: 0;
}

.kyb_help_btn {
  background: transparent;
  border: 1px solid #DAA520;
  color: #DAA520;
  padding: 12px 24px;
  border-radius: 7px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}

.kyb_help_btn:hover {
  background: #DAA520;
  color: #000;
}

.kyb_error_box {
  background: #2b3139;
  border: 1px solid #f3f4f617;
  border-radius: 18px;
  padding: 24px;
  text-align: left;
}

body.light_theme .kyb_error_box {
  background: #F9FAFB;
  border: 1px solid #F3F4F6;
}

.kyb_status_container.failled_section {
  width: 1200px;
  max-width: 100%;
  border: 1px solid #e5e7eb1f;
  border-radius: 20px;
  padding: 42px;
}

body.light_theme .kyb_status_container.failled_section {
  border: 1px solid #E5E7EB;
}

.kyb_status_container.successfull {
  width: 1200px;
  max-width: 100%;
}

.kyb_status_container.pending_section {
  width: 1200px;
  max-width: 100%;
  border: 1px solid #e5e7eb1f;
  border-radius: 20px;
  padding: 42px;
}

body.light_theme .kyb_status_container.pending_section {
  border: 1px solid #E5E7EB;
}

body.light_theme .kyb_status_container.pending_section .kyb_info_card {
  background: #F9FAFB50;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.03);
}

body.light_theme .kyb_status_container.failled_section .kyb_info_card {
  background: #F9FAFB50;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.03);
}

.kyb_error_header {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #e0e0e0;
  font-weight: 600;
  font-size: 17px;
  margin-bottom: 15px;
}

body.light_theme .kyb_error_header {
  color: #111827;
}

.kyb_error_text {
  color: #848e9c;
  font-size: 15px;
  margin-bottom: 15px;
}

.kyb_error_list {
  background: #fef2f20d;
  border: 1px solid #fee2e21c;
  border-radius: 12px;
  padding: 15px 15px 15px 30px;
  margin-bottom: 15px;
}

body.light_theme .kyb_error_list {
  background: #FEF2F280;
  border: 1px solid #FEE2E2;
}

.kyb_error_list li {
  margin-bottom: 15px;
  font-size: 14px;
  list-style: disc;
}

.kyb_error_list li:last-child {
  margin-bottom: 0;
}

.kyb_error_footer {
  color: #848e9c;
  font-size: 14px;
}

/* Success Unlocked */
.kyb_success_alert {
  background: rgba(209, 170, 103, 0.08);
  color: #d1aa67;
  letter-spacing: 0.3px;
  padding: 20px;
  border-radius: 15px;
  text-align: left;
  font-size: 17px;
  font-weight: 400;
  margin-bottom: 45px;
}

body.light_theme .kyb_success_alert {
  background: #FDF8E7;
  color: #b8893e;
}

.kyb_unlocked_section {
  text-align: left;
}

.kyb_unlocked_section h3 {
  font-size: 30px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 24px;
}

.kyb_unlocked_grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
}

@media(max-width: 991px) {
  .kyb_unlocked_grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media(max-width: 575px) {
  .kyb_unlocked_grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.kyb_unlocked_card {
  background: #1e2329;
  border: 1px solid #2b3139;
  border-radius: 20px;
  padding: 32px;
  text-align: center;
}

.kyb_unlocked_icon {
  width: 58px;
  height: 58px;
  margin: 0 auto 18px;
  background: rgba(209, 170, 103, 0.14);
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .kyb_unlocked_icon {
  background: #FDF8E7;
}

.kyb_unlocked_icon img {
  width: 20px;
}

.kyb_unlocked_card h4 {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.kyb_unlocked_card p {
  font-size: 15px;
  color: #848e9c;
  line-height: 1.4;
  margin: 0;
}

/* Light Theme Overrides */
body.light_theme .kyb_page_header h1,
body.light_theme .kyb_docs_box h3,
body.light_theme .kyb_faq_box h3,
body.light_theme .kyb_status_title,
body.light_theme .kyb_info_value,
body.light_theme .kyb_help_text h4,
body.light_theme .kyb_unlocked_section h3,
body.light_theme .kyb_unlocked_card h4 {
  color: #303236;
}

body.light_theme .kyb_box {
  background: #fff;
  border-color: #F2F3F4;
}

body.light_theme .kyb_hero_content h2 {
  color: #1e2329;
}

body.light_theme .kyb_hero_list li {
  color: #828282;
}

body.light_theme .kyb_hero_list li i {
  color: #1e2329;
  background: #ffffff00;
}

body.light_theme .kyb_doc_card {
  background: #F5F6F7;
}

body.light_theme .kyb_doc_icon {
  background: #eaecef;
}

body.light_theme .kyb_doc_info h4 {
  color: #1A1C1C;
}

body.light_theme .kyb_faq_item {
  border-color: #eaecef;
}

body.light_theme .kyb_faq_question {
  color: #1A1C1C;
}

body.light_theme .kyb_info_card {
  background: #fff;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.03);
}

body.light_theme .kyb_help_box {
  background: #fff;
  border-color: #F3F4F6;
}

body.light_theme .kyb_unlocked_card {
  background: #fff;
  border-color: #E5E7EB;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05);
}

.kyb_status_icon_wrap.failledicon {
  max-width: 218px;
}

.failled_section .kyb_status_title {
  margin-top: 20px;
}


.kyb-try-again-btn {
  background: #f6465d36;
  color: #f6465d;
  border: none;
  padding: 14px 48px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  margin-top: -10px;
  margin-bottom: 32px;
  display: inline-block;
}


.kyb_continue_btn {
  background: #2b3139;
  color: #fff;
  border: none;
  padding: 16px 48px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  margin: 0px auto 32px auto;
  display: block;
  min-width: 400px;
}

body.light_theme .kyb_continue_btn {
  background: #303236;
  color: #fff;
}


.failled_section .kyb-try-again-btn {
  margin: 0px;
}

.failled_section .kyb_help_btn {
  padding: 11px 24px;
}

@media(max-width:1200px) {

  .kyb_start_layout {
    flex-direction: column;
    gap: 10px;
  }

  .kyb_start_right {
    width: 100%;
  }

  .kyb_page_header h1 {
    font-size: 28px;
  }

  .kyb_status_title {
    font-size: 26px;
  }

  .kyb_status_desc {
    font-size: 16px;
  }

  .kyb_info_value {
    font-size: 14px;
  }

  .kyb_info_card {
    padding: 24px;
  }

  .kyb_unlocked_section h3 {
    font-size: 24px;
  }

  .kyb_unlocked_card {
    padding: 24px;
  }

  .kyb_unlocked_grid {
    grid-template-columns: repeat(2, 1fr);
  }


  .kyb_help_btn {
    padding: 10px 20px;
    font-size: 14px;
  }

  .kyb_help_box {
    flex-direction: column;
    gap: 24px;
    align-items: start;
  }

}


@media(max-width: 991px) {

  .kyb_start_layout {
    flex-direction: column;
  }

  .kyb_start_right {
    width: 100%;
  }
}

@media(max-width: 767px) {

  .kyb_page_header {
    margin-bottom: 20px;
  }

  .kyb_start_btn {
    padding: 9px 32px;
    font-size: 12px;
  }

  .kyb_verification_page {
    padding: 10px 0px;
  }

  .kyb_start_left {
    width: 100%;
  }

  .kyb_docs_grid {
    grid-template-columns: 1fr;
  }

  .kyb_page_header h1 {
    font-size: 20px;
  }

  .kyb_hero_content h2 {
    font-size: 18px;
  }

  .kyb_doc_card {
    min-height: 100%;
  }

  .kyb_page_header p {
    font-size: 14px;
  }

  .kyb_box {
    padding: 24px;
    gap: 32px;
    flex-direction: column;
  }

  .kyb_hero_img {
    width: 190px;
  }

  .kyb_doc_icon {
    width: 34px;
    min-width: 34px;
    height: 36px;
  }

  .kyb_hero_content {
    max-width: 100%;
  }


  .kyb_status_title {
    font-size: 22px;
  }

  .kyb_status_desc {
    font-size: 15px;
    margin-bottom: 20px;
  }

  .kyb_success_alert {
    padding: 14px;
    border-radius: 10px;
    font-size: 14px;
    margin-bottom: 24px;
  }

  .kyb_status_icon_wrap {
    width: 200px;
  }

  .kyb_unlocked_section h3 {
    font-size: 20px;
  }

  .kyb_status_container.pending_section {
    padding: 24px;
  }

  .kyb_status_container.failled_section {
    padding: 24px;
  }

  .kyb_error_list li {
    margin-bottom: 6px;
    font-size: 13px;
  }

  .kyb-try-again-btn {
    padding: 11px 32px;
    font-size: 14px;
    margin-top: 0px;
    margin-bottom: 22px;
  }

  .kyb_continue_btn {
    padding: 13px 32px;
    font-size: 15px;
    min-width: 280px;
  }

}


@media(max-width:480px) {

  .kyb_info_card {
    gap: 18px;
  }

  .kyb_status_title {
    font-size: 20px;
  }

  .kyb_help_icon {
    width: 44px;
    min-width: 44px;
    height: 44px;
  }

  .kyb_help_btn {
    width: 100%;
  }


  .kyb_unlocked_grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .kyb_status_icon_wrap.failledicon {
    max-width: 140px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/KYBVerification/kyb.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;;AAGA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;;;AAIA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;EACrC,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;;EAGA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;AAEF;;;AAGA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;AAEF;;;AAGA;;EAEE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;;AAEF","sourcesContent":["/* =========================================================\n   KYB Verification CSS\n   ========================================================= */\n\n.kyb_verification_page {\n  padding: 30px;\n  max-width: 100%;\n}\n\n.kyb_page_header {\n  margin-bottom: 30px;\n}\n\n.kyb_page_header h1 {\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 5px;\n  color: #fff;\n}\n\n.kyb_page_header p {\n  color: #84878A;\n  font-size: 16px;\n}\n\n/* START PAGE */\n.kyb_start_layout {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n\n.kyb_start_left {\n  flex: 1;\n}\n\n.kyb_start_right {\n  width: 360px;\n  flex-shrink: 0;\n}\n\n\n\n.kyb_box {\n  background: #2b313d52;\n  border-radius: 12px;\n  padding: 30px;\n  margin-bottom: 20px;\n  border: 1px solid #2b3139;\n}\n\n/* Hero Box */\n.kyb_hero_box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.kyb_hero_content {\n  max-width: 340px;\n}\n\n.kyb_hero_content h2 {\n  font-size: 23px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #fff;\n}\n\n.kyb_hero_content p {\n  color: #828282;\n  font-size: 14px;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.kyb_hero_list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 25px 0;\n}\n\n.kyb_hero_list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #e0e0e0;\n  font-size: 14px;\n  margin-bottom: 12px;\n}\n\n.kyb_hero_list li i {\n  height: 16px;\n  display: flex;\n  width: 16px;\n  align-items: center;\n  justify-content: center;\n  min-width: 16px;\n  color: #b7b7b7;\n  background: #ffffff00;\n  border: 1px solid #a3a3a3;\n  border-radius: 50%;\n  font-size: 12px;\n}\n\n.kyb_start_btn {\n  background: #2b313c;\n  color: #fff;\n  border: none;\n  padding: 13px 32px;\n  border-radius: 50px;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n  font-size: 13px;\n  transition: opacity 0.2s;\n  cursor: pointer;\n}\n\n.kyb_start_btn:hover {\n  opacity: 0.8;\n}\n\n.kyb_start_btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.kyb_status_cta {\n  margin: 8px 0 24px;\n}\n\n.kyb_status_actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  margin: 8px 0 24px;\n}\n\n.kyb_status_banner {\n  margin: 0 0 16px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(209, 170, 103, 0.35);\n  background: rgba(209, 170, 103, 0.08);\n}\n\n.kyb_status_banner_title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #d1aa67;\n  margin-bottom: 6px;\n}\n\n.kyb_status_banner_text {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #cdcdcd;\n}\n\n.kyb_status_vendor {\n  display: inline-block;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #a3a3a3;\n}\n\n.kyb_info_value.pending_value {\n  color: #d1aa67;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.kyb_help_btn_outline {\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n}\n\n.kyb_hero_img {\n  width: 350px;\n}\n\n/* Required Documents Box */\n.kyb_docs_box h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #fff;\n}\n\n.kyb_docs_box>p {\n  color: #cdcdcd;\n  font-size: 13px;\n  margin-bottom: 20px;\n}\n\nbody.light_theme .kyb_docs_box>p {\n  color: #4E4638;\n}\n\n.kyb_docs_grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.kyb_doc_card {\n  background: #2b313c91;\n  border-radius: 8px;\n  min-height: 105px;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.kyb_doc_icon {\n  width: 34px;\n  min-width: 34px;\n  height: 42px;\n  background: #858585;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .kyb_doc_icon {\n  background: #1e2329;\n}\n\n.kyb_doc_icon img {\n  width: auto;\n  object-fit: contain;\n  filter: invert(1);\n}\n\nbody.light_theme .kyb_doc_icon img {\n  filter: invert(0);\n}\n\n.kyb_doc_info h4 {\n  font-size: 13px;\n  letter-spacing: 0.8px;\n  font-weight: 500;\n  color: #fff;\n  margin-bottom: 3px;\n}\n\n.kyb_doc_info p {\n  font-size: 12px;\n  color: #cfcfcf;\n  margin: 0;\n  line-height: 1.4;\n}\n\nbody.light_theme .kyb_doc_info p {\n  color: #4E4638;\n}\n\n/* FAQ Box */\n.kyb_faq_box h3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #fff;\n}\n\n.kyb_faq_list {\n  display: flex;\n  flex-direction: column;\n}\n\n.kyb_faq_item {\n  border-bottom: 1px solid #2b3139;\n}\n\n.kyb_faq_item:last-child {\n  border-bottom: none;\n}\n\n.kyb_faq_question {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 0;\n  color: #e0e0e0;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.kyb_faq_question i {\n  color: #848e9c;\n}\n\n.kyb_faq_answer {\n  padding-bottom: 15px;\n  color: #848e9c;\n  font-size: 13px;\n  line-height: 1.5;\n  display: none;\n}\n\n.kyb_faq_item.active .kyb_faq_answer {\n  display: block;\n}\n\n.kyb_faq_item.active .kyb_faq_question i {\n  transform: rotate(180deg);\n}\n\n/* STATUS PAGES (Pending, Success, Failed) */\n.kyb_status_container {\n  width: 100%;\n  text-align: center;\n}\n\n.kyb_status_icon_wrap {\n  width: 360px;\n  /* height: 80px; */\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kyb_status_icon_wrap img {\n  object-fit: contain;\n}\n\n.kyb_status_title {\n  font-size: 38px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 10px;\n  margin-top: -40px;\n}\n\n.successfull .kyb_status_title {\n  margin-top: 0px;\n}\n\n.kyb_status_title span.pending {\n  color: #DAA520;\n}\n\n.kyb_status_container.pending_section h2 {\n  margin-top: 20px;\n}\n\n.kyb_status_title span.failed {\n  color: #f6465d;\n}\n\n.kyb_status_title span.success {\n  color: #d1aa67;\n}\n\n.kyb_status_desc {\n  color: #84878A;\n  font-size: 18px;\n  margin-bottom: 40px;\n}\n\n/* Info Grid */\n.kyb_info_card {\n  background: #2b3139;\n  border-radius: 20px;\n  padding: 36px;\n  border: 1px solid #f2f3f417;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 26px;\n  text-align: left;\n  margin-bottom: 30px;\n}\n\nbody.light_theme .kyb_info_card {\n  border: 1px solid #F2F3F4;\n}\n\n@media(max-width: 600px) {\n  .kyb_info_card {\n    grid-template-columns: 1fr;\n  }\n}\n\n.kyb_info_item {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.kyb_info_icon {\n  background-color: rgba(209, 170, 103, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n}\n\nbody.light_theme .kyb_info_icon {\n  background-color: #FDF8E7;\n}\n\n.kyb_info_text {\n  flex: 1;\n}\n\n.kyb_info_label {\n  color: #848e9c;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.failled_section .kyb_info_icon {\n  background-color: #fef2f208;\n}\n\nbody.light_theme .failled_section .kyb_info_icon {\n  background-color: #FEF2F2;\n}\n\n.kyb_info_value {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.kyb_info_value.failed {\n  color: #f6465d;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(246, 70, 93, 0.1);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.kyb_info_value.success {\n  color: #d1aa67 !important;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(209, 170, 103, 0.14);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n/* Alerts / Extra Boxes */\n.kyb_help_box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: rgba(240, 185, 11, 0.05);\n  border: 1px solid rgba(240, 185, 11, 0.2);\n  border-radius: 12px;\n  padding: 24px;\n  text-align: left;\n}\n\n.kyb_help_left {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.kyb_help_icon {\n  width: 64px;\n  min-width: 64px;\n  height: 64px;\n  background: #fdf8e70f;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .kyb_help_icon {\n  background: #FDF8E7;\n}\n\n.kyb_help_text h4 {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 5px;\n}\n\n.kyb_help_text p {\n  color: #848e9c;\n  font-size: 14px;\n  margin: 0;\n}\n\n.kyb_help_btn {\n  background: transparent;\n  border: 1px solid #DAA520;\n  color: #DAA520;\n  padding: 12px 24px;\n  border-radius: 7px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.kyb_help_btn:hover {\n  background: #DAA520;\n  color: #000;\n}\n\n.kyb_error_box {\n  background: #2b3139;\n  border: 1px solid #f3f4f617;\n  border-radius: 18px;\n  padding: 24px;\n  text-align: left;\n}\n\nbody.light_theme .kyb_error_box {\n  background: #F9FAFB;\n  border: 1px solid #F3F4F6;\n}\n\n.kyb_status_container.failled_section {\n  width: 1200px;\n  max-width: 100%;\n  border: 1px solid #e5e7eb1f;\n  border-radius: 20px;\n  padding: 42px;\n}\n\nbody.light_theme .kyb_status_container.failled_section {\n  border: 1px solid #E5E7EB;\n}\n\n.kyb_status_container.successfull {\n  width: 1200px;\n  max-width: 100%;\n}\n\n.kyb_status_container.pending_section {\n  width: 1200px;\n  max-width: 100%;\n  border: 1px solid #e5e7eb1f;\n  border-radius: 20px;\n  padding: 42px;\n}\n\nbody.light_theme .kyb_status_container.pending_section {\n  border: 1px solid #E5E7EB;\n}\n\nbody.light_theme .kyb_status_container.pending_section .kyb_info_card {\n  background: #F9FAFB50;\n  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.03);\n}\n\nbody.light_theme .kyb_status_container.failled_section .kyb_info_card {\n  background: #F9FAFB50;\n  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.03);\n}\n\n.kyb_error_header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #e0e0e0;\n  font-weight: 600;\n  font-size: 17px;\n  margin-bottom: 15px;\n}\n\nbody.light_theme .kyb_error_header {\n  color: #111827;\n}\n\n.kyb_error_text {\n  color: #848e9c;\n  font-size: 15px;\n  margin-bottom: 15px;\n}\n\n.kyb_error_list {\n  background: #fef2f20d;\n  border: 1px solid #fee2e21c;\n  border-radius: 12px;\n  padding: 15px 15px 15px 30px;\n  margin-bottom: 15px;\n}\n\nbody.light_theme .kyb_error_list {\n  background: #FEF2F280;\n  border: 1px solid #FEE2E2;\n}\n\n.kyb_error_list li {\n  margin-bottom: 15px;\n  font-size: 14px;\n  list-style: disc;\n}\n\n.kyb_error_list li:last-child {\n  margin-bottom: 0;\n}\n\n.kyb_error_footer {\n  color: #848e9c;\n  font-size: 14px;\n}\n\n/* Success Unlocked */\n.kyb_success_alert {\n  background: rgba(209, 170, 103, 0.08);\n  color: #d1aa67;\n  letter-spacing: 0.3px;\n  padding: 20px;\n  border-radius: 15px;\n  text-align: left;\n  font-size: 17px;\n  font-weight: 400;\n  margin-bottom: 45px;\n}\n\nbody.light_theme .kyb_success_alert {\n  background: #FDF8E7;\n  color: #b8893e;\n}\n\n.kyb_unlocked_section {\n  text-align: left;\n}\n\n.kyb_unlocked_section h3 {\n  font-size: 30px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 24px;\n}\n\n.kyb_unlocked_grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 15px;\n}\n\n@media(max-width: 991px) {\n  .kyb_unlocked_grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media(max-width: 575px) {\n  .kyb_unlocked_grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.kyb_unlocked_card {\n  background: #1e2329;\n  border: 1px solid #2b3139;\n  border-radius: 20px;\n  padding: 32px;\n  text-align: center;\n}\n\n.kyb_unlocked_icon {\n  width: 58px;\n  height: 58px;\n  margin: 0 auto 18px;\n  background: rgba(209, 170, 103, 0.14);\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .kyb_unlocked_icon {\n  background: #FDF8E7;\n}\n\n.kyb_unlocked_icon img {\n  width: 20px;\n}\n\n.kyb_unlocked_card h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 8px;\n}\n\n.kyb_unlocked_card p {\n  font-size: 15px;\n  color: #848e9c;\n  line-height: 1.4;\n  margin: 0;\n}\n\n/* Light Theme Overrides */\nbody.light_theme .kyb_page_header h1,\nbody.light_theme .kyb_docs_box h3,\nbody.light_theme .kyb_faq_box h3,\nbody.light_theme .kyb_status_title,\nbody.light_theme .kyb_info_value,\nbody.light_theme .kyb_help_text h4,\nbody.light_theme .kyb_unlocked_section h3,\nbody.light_theme .kyb_unlocked_card h4 {\n  color: #303236;\n}\n\nbody.light_theme .kyb_box {\n  background: #fff;\n  border-color: #F2F3F4;\n}\n\nbody.light_theme .kyb_hero_content h2 {\n  color: #1e2329;\n}\n\nbody.light_theme .kyb_hero_list li {\n  color: #828282;\n}\n\nbody.light_theme .kyb_hero_list li i {\n  color: #1e2329;\n  background: #ffffff00;\n}\n\nbody.light_theme .kyb_doc_card {\n  background: #F5F6F7;\n}\n\nbody.light_theme .kyb_doc_icon {\n  background: #eaecef;\n}\n\nbody.light_theme .kyb_doc_info h4 {\n  color: #1A1C1C;\n}\n\nbody.light_theme .kyb_faq_item {\n  border-color: #eaecef;\n}\n\nbody.light_theme .kyb_faq_question {\n  color: #1A1C1C;\n}\n\nbody.light_theme .kyb_info_card {\n  background: #fff;\n  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.03);\n}\n\nbody.light_theme .kyb_help_box {\n  background: #fff;\n  border-color: #F3F4F6;\n}\n\nbody.light_theme .kyb_unlocked_card {\n  background: #fff;\n  border-color: #E5E7EB;\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05);\n}\n\n.kyb_status_icon_wrap.failledicon {\n  max-width: 218px;\n}\n\n.failled_section .kyb_status_title {\n  margin-top: 20px;\n}\n\n\n.kyb-try-again-btn {\n  background: #f6465d36;\n  color: #f6465d;\n  border: none;\n  padding: 14px 48px;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: -10px;\n  margin-bottom: 32px;\n  display: inline-block;\n}\n\n\n.kyb_continue_btn {\n  background: #2b3139;\n  color: #fff;\n  border: none;\n  padding: 16px 48px;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 18px;\n  cursor: pointer;\n  margin: 0px auto 32px auto;\n  display: block;\n  min-width: 400px;\n}\n\nbody.light_theme .kyb_continue_btn {\n  background: #303236;\n  color: #fff;\n}\n\n\n.failled_section .kyb-try-again-btn {\n  margin: 0px;\n}\n\n.failled_section .kyb_help_btn {\n  padding: 11px 24px;\n}\n\n@media(max-width:1200px) {\n\n  .kyb_start_layout {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .kyb_start_right {\n    width: 100%;\n  }\n\n  .kyb_page_header h1 {\n    font-size: 28px;\n  }\n\n  .kyb_status_title {\n    font-size: 26px;\n  }\n\n  .kyb_status_desc {\n    font-size: 16px;\n  }\n\n  .kyb_info_value {\n    font-size: 14px;\n  }\n\n  .kyb_info_card {\n    padding: 24px;\n  }\n\n  .kyb_unlocked_section h3 {\n    font-size: 24px;\n  }\n\n  .kyb_unlocked_card {\n    padding: 24px;\n  }\n\n  .kyb_unlocked_grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n\n  .kyb_help_btn {\n    padding: 10px 20px;\n    font-size: 14px;\n  }\n\n  .kyb_help_box {\n    flex-direction: column;\n    gap: 24px;\n    align-items: start;\n  }\n\n}\n\n\n@media(max-width: 991px) {\n\n  .kyb_start_layout {\n    flex-direction: column;\n  }\n\n  .kyb_start_right {\n    width: 100%;\n  }\n}\n\n@media(max-width: 767px) {\n\n  .kyb_page_header {\n    margin-bottom: 20px;\n  }\n\n  .kyb_start_btn {\n    padding: 9px 32px;\n    font-size: 12px;\n  }\n\n  .kyb_verification_page {\n    padding: 10px 0px;\n  }\n\n  .kyb_start_left {\n    width: 100%;\n  }\n\n  .kyb_docs_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .kyb_page_header h1 {\n    font-size: 20px;\n  }\n\n  .kyb_hero_content h2 {\n    font-size: 18px;\n  }\n\n  .kyb_doc_card {\n    min-height: 100%;\n  }\n\n  .kyb_page_header p {\n    font-size: 14px;\n  }\n\n  .kyb_box {\n    padding: 24px;\n    gap: 32px;\n    flex-direction: column;\n  }\n\n  .kyb_hero_img {\n    width: 190px;\n  }\n\n  .kyb_doc_icon {\n    width: 34px;\n    min-width: 34px;\n    height: 36px;\n  }\n\n  .kyb_hero_content {\n    max-width: 100%;\n  }\n\n\n  .kyb_status_title {\n    font-size: 22px;\n  }\n\n  .kyb_status_desc {\n    font-size: 15px;\n    margin-bottom: 20px;\n  }\n\n  .kyb_success_alert {\n    padding: 14px;\n    border-radius: 10px;\n    font-size: 14px;\n    margin-bottom: 24px;\n  }\n\n  .kyb_status_icon_wrap {\n    width: 200px;\n  }\n\n  .kyb_unlocked_section h3 {\n    font-size: 20px;\n  }\n\n  .kyb_status_container.pending_section {\n    padding: 24px;\n  }\n\n  .kyb_status_container.failled_section {\n    padding: 24px;\n  }\n\n  .kyb_error_list li {\n    margin-bottom: 6px;\n    font-size: 13px;\n  }\n\n  .kyb-try-again-btn {\n    padding: 11px 32px;\n    font-size: 14px;\n    margin-top: 0px;\n    margin-bottom: 22px;\n  }\n\n  .kyb_continue_btn {\n    padding: 13px 32px;\n    font-size: 15px;\n    min-width: 280px;\n  }\n\n}\n\n\n@media(max-width:480px) {\n\n  .kyb_info_card {\n    gap: 18px;\n  }\n\n  .kyb_status_title {\n    font-size: 20px;\n  }\n\n  .kyb_help_icon {\n    width: 44px;\n    min-width: 44px;\n    height: 44px;\n  }\n\n  .kyb_help_btn {\n    width: 100%;\n  }\n\n\n  .kyb_unlocked_grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .kyb_status_icon_wrap.failledicon {\n    max-width: 140px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
